import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

import { XCircleIcon, DropdownChevron } from 'images/common';

export default class CustomMultiSelect extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isFocussed: false,
      options: props.options || [],
      value: props.value || [],
      inputVal: ''
    };
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    this.setState({
      options: nextProps.options || [],
      value: nextProps.value !== 'undefined' ? nextProps.value : [],
    });
  }

  toggleFocussed = () => {
    if (this.props.readOnly) {
      return;
    }
    this.setState({ inputVal: '' });

    if (!this.state.isFocussed) {
      this.setState({ options: this.props.options });
    }

    setTimeout(() => {
      this.setState({
        isFocussed: !this.state.isFocussed,
      });
    }, 200);
  };

  selectOption(selectedOption) {
    if (!this.state.value.includes(selectedOption)) {
      this.setState(
        {
          value: this.state.value.concat([selectedOption]),
        },
        () => {
          this.props.onChange(this.state.value);
        },
      );
    }
  }

  onChange = (e) => {
    const { value } = e.target;
    const activeList = this.props.options.filter(opt => opt.label.toLowerCase().includes(value.toLowerCase()));

    this.setState({ inputVal: value });
    this.setState({ options: activeList });
  };

  removeValue(id) {
    if (this.props.readOnly) {
      return;
    }

    const index = this.state.value.indexOf(id);
    const values = this.state.value.concat([]);

    if (typeof (values) === 'string') {
      return this.setState(
        {
          value: values.replace(id, ''),
        },
        () => {
          this.props.onChange(this.state.value);
        },
      );
    }

    values && values.splice(index, 1);
    this.setState(
      {
        value: values,
      },
      () => {
        this.props.onChange(this.state.value);
      },
    );
  }

  render() {
    const { options, value } = this.state;
    const { label, allOptions, color, rectangularTags, isAlt, borderInput, showAllOption } = this.props;

    const inputClass = classNames({
      'select-field__input': true,
      'select-field__input_filled': value && value.length,
      'select-field__input_focused': !!this.state.isFocussed,
      'select-field__input--rect': rectangularTags,
      'select-field__input--border': borderInput
    });

    const parentClass = classNames('select-field select-field_accent1', {
      'text-field_invalid': this.props.isInvalid,
      [this.props.parentClass]: this.props.parentClass,
      'select-field--border': borderInput
    });

    return (
      <div
        className={classNames(parentClass, {
          'select-field_readonly': this.props.readOnly,
        })}
      >
        <div className={classNames('select-field__chevron', borderInput && 'select-field__chevron--border')}>
          <DropdownChevron />
        </div>
        <div className={classNames('select-field__options', {
          'select-field__value': this.state.inputVal,
          'select-field__options--rect': rectangularTags,
          'select-field__options--border': borderInput
        })}
        >
          {showAllOption && this.props.value.length === 0 && <span className='select-field__all-label'>{showAllOption}</span>}
          {this.props.value && (allOptions || options || [])
            .filter(opt => this.props.value.includes(opt.value))
            .map(opt => (
              <span className={classNames('select-field__tag', borderInput && 'select-field__tag--border')} key={opt.label}>
                <span
                  className={
                    classNames(
                      `tags_${color} tags__item text-color select-field__options_${color}`,
                      rectangularTags && `tags__item--rect tags__item--rect--${isAlt ? `alt-${color}` : color}`,
                      rectangularTags && isAlt && 'tags__item--rect--alt'
                    )
                  }
                  key={opt.value}
                  onClick={() => {
                    this.removeValue(opt.value);
                  }}
                >
                  {opt.label}
                  {!rectangularTags &&
                    <button
                      type="button"
                      className="tags__remove"
                      onClick={() => this.removeValue(opt.value)}
                    >
                      <XCircleIcon />
                    </button>
                  }
                </span>
              </span>
            ))}
        </div>
        <input
          type="text"
          data-cy={this.props.dataCy}
          onChange={this.onChange}
          value={this.state.inputVal}
          className={inputClass}
          disabled={this.props.disabled}
          readOnly={this.props.disabled}
          onFocus={this.toggleFocussed}
          onBlur={this.toggleFocussed}
        />
        <label className={classNames(
          'select-field__label',
          rectangularTags && 'select-field__label--rect',
          borderInput && 'select-field__label--border'
        )}
        >
          {label}
        </label>
        {!borderInput && <div className='select-field__underscore' />}
        <div className={classNames('text-field__hint text-field__hint_r', {
          'show-password': this.props.hintText,
        })}
        >
          {this.props.hintText}
        </div>
        <div className={classNames('select-field__dropdown', borderInput && 'select-field__dropdown--border')}>
          <Scrollbars
            autoHide
            autoHideDuration={1}
            style={{ maxHeight: '312px', minHeight: '147px' }}
            universal
            renderThumbVertical={props => (
              <div {...props} className="thumb-vertical" />
            )}
          >
            {(options || [])
              .filter(opt => !value.includes(opt.value))
              .map((opt) => {
                const itemClass = classNames(
                  'select-field__option select-field__option_multi',
                  {
                    'no-cursor': opt.children && opt.children.length,
                  },
                );

                return (
                  <div key={opt.value}>
                    <div
                      data-label={opt.label}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!opt.children || !opt.children.length) {
                          this.selectOption(opt.value);
                        }
                      }}
                      className={itemClass}
                    >
                      {opt.label}
                    </div>
                    {opt.children
                      && opt.children
                        .filter(item => !value.includes(item.value))
                        .map(item => (
                          <div
                            data-label={item.label}
                            key={item.value}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.selectOption(item.value);
                            }}
                            className="select-field__option select-field__option_multi"
                          >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {item.label}
                          </div>
                        ))}
                  </div>
                );
              })}
          </Scrollbars>
        </div>
        {!borderInput && <div className='select-field__underscore' />}
      </div>
    );
  }
}

CustomMultiSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  parentClass: PropTypes.string,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  rectangularTags: PropTypes.bool
}